// extracted by mini-css-extract-plugin
export default {"players-panel-wrap":"PlayersPanel_players-panel-wrap__5sX+n","players-panel":"PlayersPanel_players-panel__4aU7U","pointer":"PlayersPanel_pointer__Tla8m"};